/*! For license information please see index.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactCookieLaw = t(require("react")) : e.ReactCookieLaw = t(e.react);
}(global, function (e) {
  return function () {
    var t = {
      805: function _(e, t, o) {
        "use strict";

        o.r(t), o.d(t, {
          CookieBanner: function CookieBanner() {
            return X;
          }
        });
        var n = o(297),
            r = o.n(n),
            i = o(697),
            c = o.n(i),
            s = o(489);

        function a(e, t) {
          void 0 === t && (t = {});

          var o = function (e) {
            return e && "j" === e[0] && ":" === e[1] ? e.substr(2) : e;
          }(e);

          if (function (e, t) {
            return void 0 === t && (t = !e || "{" !== e[0] && "[" !== e[0] && '"' !== e[0]), !t;
          }(o, t.doNotParse)) try {
            return JSON.parse(o);
          } catch (e) {}
          return e;
        }

        var _l = function l() {
          return (_l = Object.assign || function (e) {
            for (var t, o = 1, n = arguments.length; o < n; o++) {
              for (var r in t = arguments[o]) {
                Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              }
            }

            return e;
          }).apply(this, arguments);
        };

        var u = function () {
          function e(e, t) {
            var o = this;
            this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.cookies = function (e, t) {
              return "string" == typeof e ? s.Q(e, t) : "object" == typeof e && null !== e ? e : {};
            }(e, t), new Promise(function () {
              o.HAS_DOCUMENT_COOKIE = "object" == typeof document && "string" == typeof document.cookie;
            }).catch(function () {});
          }

          return e.prototype._updateBrowserValues = function (e) {
            this.HAS_DOCUMENT_COOKIE && (this.cookies = s.Q(document.cookie, e));
          }, e.prototype._emitChange = function (e) {
            for (var t = 0; t < this.changeListeners.length; ++t) {
              this.changeListeners[t](e);
            }
          }, e.prototype.get = function (e, t, o) {
            return void 0 === t && (t = {}), this._updateBrowserValues(o), a(this.cookies[e], t);
          }, e.prototype.getAll = function (e, t) {
            void 0 === e && (e = {}), this._updateBrowserValues(t);
            var o = {};

            for (var n in this.cookies) {
              o[n] = a(this.cookies[n], e);
            }

            return o;
          }, e.prototype.set = function (e, t, o) {
            var n;
            "object" == typeof t && (t = JSON.stringify(t)), this.cookies = _l(_l({}, this.cookies), ((n = {})[e] = t, n)), this.HAS_DOCUMENT_COOKIE && (document.cookie = s.q(e, t, o)), this._emitChange({
              name: e,
              value: t,
              options: o
            });
          }, e.prototype.remove = function (e, t) {
            var o = t = _l(_l({}, t), {
              expires: new Date(1970, 1, 1, 0, 0, 1),
              maxAge: 0
            });

            this.cookies = _l({}, this.cookies), delete this.cookies[e], this.HAS_DOCUMENT_COOKIE && (document.cookie = s.q(e, "", o)), this._emitChange({
              name: e,
              value: void 0,
              options: t
            });
          }, e.prototype.addChangeListener = function (e) {
            this.changeListeners.push(e);
          }, e.prototype.removeChangeListener = function (e) {
            var t = this.changeListeners.indexOf(e);
            t >= 0 && this.changeListeners.splice(t, 1);
          }, e;
        }();

        var f = function f() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 365,
              o = e ? new Date(e) : new Date();
          return o.setTime(o.getTime() + 24 * t * 60 * 60 * 1e3), o;
        },
            p = function p() {
          return "undefined" == typeof navigator;
        };

        function h(e, t) {
          var o = Object.keys(e);

          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), o.push.apply(o, n);
          }

          return o;
        }

        function y(e, t, o) {
          return t in e ? Object.defineProperty(e, t, {
            value: o,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = o, e;
        }

        function d(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function g(e, t) {
          for (var o = 0; o < t.length; o++) {
            var n = t[o];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        var v = function () {
          function e() {
            var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            d(this, e), this.cookies = new u(), this.whole_domain = t;
          }

          var t, o;
          return t = e, (o = [{
            key: "get",
            value: function value(e) {
              return this.cookies.get(e);
            }
          }, {
            key: "set",
            value: function value(e, t) {
              var o = this.whole_domain ? {
                path: "/"
              } : {};
              this.cookies.set(e, !0, function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var o = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? h(Object(o), !0).forEach(function (t) {
                    y(e, t, o[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : h(Object(o)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
                  });
                }

                return e;
              }({
                expires: t || f()
              }, {
                optionPath: o
              }));
            }
          }, {
            key: "remove",
            value: function value(e) {
              return this.cookies.remove(e);
            }
          }]) && g(t.prototype, o), e;
        }();

        var b = {
          dialog: {
            position: "fixed",
            top: "0",
            left: "0",
            right: "0",
            zIndex: "100000",
            backgroundColor: "#f8f7f7",
            padding: "10px"
          },
          container: {
            maxWidth: "960px",
            marginLeft: "auto",
            marginRight: "auto",
            overflow: "hidden"
          },
          message: {
            minHeight: "32px",
            fontSize: "10pt",
            fontWeight: "400",
            lineHeight: "130%",
            padding: "10px 0",
            color: "#000000"
          },
          policy: {
            fontSize: "10pt",
            marginLeft: "10px",
            color: "#000000",
            textDecoration: "underline"
          },
          selectPane: {
            display: "table-cell",
            padding: "3px 0px 10px 0px"
          },
          optionWrapper: {
            display: "inline-block",
            position: "relative",
            marginRight: "7px",
            marginLeft: "7px",
            float: "left"
          },
          optionLabel: {
            height: "auto",
            width: "auto",
            minHeight: "14px",
            fontSize: "12pt",
            color: "#c6c6c6",
            display: "inline-block",
            padding: "1px 0 0 20px",
            position: "relative",
            top: "0",
            left: "0",
            zIndex: "1",
            cursor: "default",
            verticalAlign: "top"
          },
          checkbox: {
            position: "absolute",
            top: "4px",
            left: "0",
            width: "14px",
            height: "14px",
            zIndex: "2",
            cursor: "pointer"
          },
          buttonWrapper: {
            float: "right"
          },
          button: {
            display: "inline-block",
            backgroundColor: "#000000",
            padding: "3px",
            minWidth: "80px",
            color: "#ffffff",
            textDecoration: "none",
            fontSize: "10pt",
            fontWeight: "400",
            marginRight: "5px",
            marginLeft: "5px",
            textAlign: "center",
            whiteSpace: "nowrap",
            cursor: "pointer"
          }
        };

        function m(e) {
          return (m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          })(e);
        }

        function k() {
          return (k = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var o = arguments[t];

              for (var n in o) {
                Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
              }
            }

            return e;
          }).apply(this, arguments);
        }

        function O(e, t) {
          for (var o = 0; o < t.length; o++) {
            var n = t[o];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        function w(e, t) {
          return (w = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          })(e, t);
        }

        function x(e, t) {
          return !t || "object" !== m(t) && "function" != typeof t ? S(e) : t;
        }

        function S(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }

        function P(e) {
          return (P = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
        }

        var C = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && w(e, t);
          }(s, e);
          var t,
              o,
              n,
              i,
              c = (n = s, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = P(n);

            if (i) {
              var o = P(this).constructor;
              e = Reflect.construct(t, arguments, o);
            } else e = t.apply(this, arguments);

            return x(this, e);
          });

          function s(e) {
            var t;
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, s), t = c.call(this, e);
            var o = e.checked,
                n = void 0 !== o && o;
            return t.state = {
              checked: n
            }, t.handleOnChange = t.handleOnChange.bind(S(t)), t;
          }

          return t = s, (o = [{
            key: "handleOnChange",
            value: function value() {
              var e = this.props.onChange,
                  t = void 0 === e ? function () {} : e,
                  o = !this.state.checked;
              this.setState({
                checked: o
              }), t(o);
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                  t = e.id,
                  o = void 0 === t ? "" : t,
                  n = e.text,
                  i = void 0 === n ? "" : n,
                  c = e.styles,
                  s = void 0 === c ? {} : c,
                  a = e.disabled,
                  l = void 0 !== a && a,
                  u = l ? {
                disabled: l
              } : {},
                  f = this.state.checked,
                  p = s.optionWrapperStyle,
                  h = s.optionLabelStyle,
                  y = s.checkboxStyle;
              return r().createElement("div", {
                className: "react-cookie-law-option-wrapper",
                style: p
              }, r().createElement("input", k({
                type: "checkbox",
                id: o,
                className: "react-cookie-law-option-checkbox",
                style: y,
                checked: f,
                onChange: this.handleOnChange
              }, u)), r().createElement("label", {
                htmlFor: o,
                style: h
              }, i));
            }
          }]) && O(t.prototype, o), s;
        }(r().Component);

        function T(e, t) {
          var o = Object.keys(e);

          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), o.push.apply(o, n);
          }

          return o;
        }

        function j(e) {
          for (var t = 1; t < arguments.length; t++) {
            var o = null != arguments[t] ? arguments[t] : {};
            t % 2 ? T(Object(o), !0).forEach(function (t) {
              E(e, t, o[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : T(Object(o)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
            });
          }

          return e;
        }

        function E(e, t, o) {
          return t in e ? Object.defineProperty(e, t, {
            value: o,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = o, e;
        }

        var _ = function _() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = e.styles,
              o = void 0 === t ? {} : t,
              n = e.necessaryOptionText,
              i = void 0 === n ? "Necessary" : n,
              c = e.preferencesOptionText,
              s = void 0 === c ? "Preferences" : c,
              a = e.statisticsOptionText,
              l = void 0 === a ? "Statistics" : a,
              u = e.marketingOptionText,
              f = void 0 === u ? "Marketing" : u,
              p = e.showPreferencesOption,
              h = void 0 === p || p,
              y = e.showStatisticsOption,
              d = void 0 === y || y,
              g = e.showMarketingOption,
              v = void 0 === g || g,
              m = e.preferencesDefaultChecked,
              k = void 0 !== m && m,
              O = e.statisticsDefaultChecked,
              w = void 0 !== O && O,
              x = e.marketingDefaultChecked,
              S = void 0 !== x && x,
              P = e.onTogglePreferencesCookies,
              T = void 0 === P ? function () {} : P,
              E = e.onToggleStatisticsCookies,
              _ = void 0 === E ? function () {} : E,
              D = e.onToggleMarketingCookies,
              A = void 0 === D ? function () {} : D,
              L = j(j({}, b), o),
              R = L.selectPane,
              M = L.optionWrapper,
              N = L.optionLabel,
              B = L.checkbox,
              U = {
            optionWrapperStyle: M,
            optionLabelStyle: N,
            checkboxStyle: B
          };

          return r().createElement("div", {
            className: "react-cookie-law-select-pane",
            style: R
          }, r().createElement(C, {
            id: "check-required-cookies",
            text: i,
            styles: U,
            disabled: !0,
            checked: !0
          }), h && r().createElement(C, {
            id: "check-preferences-cookies",
            text: s,
            styles: U,
            checked: k,
            onChange: T
          }), d && r().createElement(C, {
            id: "check-statistics-cookies",
            text: l,
            styles: U,
            checked: w,
            onChange: _
          }), v && r().createElement(C, {
            id: "check-marketing-cookies",
            text: f,
            styles: U,
            checked: S,
            onChange: A
          }));
        };

        function D(e) {
          return (D = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          })(e);
        }

        function A(e, t) {
          var o = Object.keys(e);

          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), o.push.apply(o, n);
          }

          return o;
        }

        function L(e) {
          for (var t = 1; t < arguments.length; t++) {
            var o = null != arguments[t] ? arguments[t] : {};
            t % 2 ? A(Object(o), !0).forEach(function (t) {
              R(e, t, o[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : A(Object(o)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
            });
          }

          return e;
        }

        function R(e, t, o) {
          return t in e ? Object.defineProperty(e, t, {
            value: o,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = o, e;
        }

        function M(e, t) {
          for (var o = 0; o < t.length; o++) {
            var n = t[o];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        function N(e, t) {
          return (N = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          })(e, t);
        }

        function B(e, t) {
          return !t || "object" !== D(t) && "function" != typeof t ? function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e) : t;
        }

        function U(e) {
          return (U = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
        }

        var I = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && N(e, t);
          }(s, e);
          var t,
              o,
              n,
              i,
              c = (n = s, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = U(n);

            if (i) {
              var o = U(this).constructor;
              e = Reflect.construct(t, arguments, o);
            } else e = t.apply(this, arguments);

            return B(this, e);
          });

          function s(e) {
            var t;
            return function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, s), (t = c.call(this, e)).state = {
              showPreferences: !1
            }, t;
          }

          return t = s, (o = [{
            key: "render",
            value: function value() {
              var e = this,
                  t = this.props,
                  o = t.styles,
                  n = void 0 === o ? {} : o,
                  i = t.className,
                  c = void 0 === i ? "" : i,
                  s = t.message,
                  a = void 0 === s ? "No text" : s,
                  l = t.policyLink,
                  u = void 0 === l ? "/#" : l,
                  f = t.privacyPolicyLinkText,
                  p = void 0 === f ? "Privacy Policy" : f,
                  h = t.acceptButtonText,
                  y = void 0 === h ? "Accept all" : h,
                  d = t.managePreferencesButtonText,
                  g = void 0 === d ? "Mange my cookies" : d,
                  v = t.savePreferencesButtonText,
                  m = void 0 === v ? "Save and close" : v,
                  k = t.onConfirm,
                  O = void 0 === k ? function () {} : k,
                  w = t.onAcceptAll,
                  x = void 0 === w ? function () {} : w,
                  S = this.state.showPreferences,
                  P = L(L({}, b), n),
                  C = P.dialog,
                  T = P.container,
                  j = P.message,
                  E = P.policy,
                  D = P.buttonWrapper,
                  A = P.button;
              return r().createElement("div", {
                className: "react-cookie-law-dialog ".concat(c),
                style: C
              }, r().createElement("div", {
                className: "react-cookie-law-container",
                style: T
              }, r().createElement("div", {
                className: "react-cookie-law-msg",
                style: j
              }, a), S && r().createElement(_, this.props), r().createElement("a", {
                href: u,
                className: "react-cookie-law-policy",
                style: E
              }, p), r().createElement("div", {
                className: "react-cookie-law-button-wrapper",
                style: D
              }, S ? r().createElement("button", {
                type: "button",
                className: "react-cookie-law-save-btn",
                style: A,
                onClick: function onClick() {
                  return O();
                }
              }, r().createElement("span", null, m)) : r().createElement("button", {
                type: "button",
                className: "react-cookie-law-manage-btn",
                style: A,
                onClick: function onClick() {
                  return e.setState({
                    showPreferences: !0
                  });
                }
              }, r().createElement("span", null, g)), r().createElement("button", {
                type: "button",
                className: "react-cookie-law-accept-btn",
                style: A,
                onClick: function onClick() {
                  return x();
                }
              }, r().createElement("span", null, y)))));
            }
          }]) && M(t.prototype, o), s;
        }(r().Component);

        function W(e) {
          return (W = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          })(e);
        }

        function H(e, t) {
          for (var o = 0; o < t.length; o++) {
            var n = t[o];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        function q(e, t) {
          return (q = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          })(e, t);
        }

        function z(e, t) {
          return !t || "object" !== W(t) && "function" != typeof t ? K(e) : t;
        }

        function K(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }

        function V(e) {
          return (V = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
        }

        var F = "rcl_consent_given",
            Q = "rcl_preferences_consent",
            J = "rcl_statistics_consent",
            Y = "rcl_marketing_consent",
            $ = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && q(e, t);
          }(s, e);
          var t,
              o,
              n,
              i,
              c = (n = s, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = V(n);

            if (i) {
              var o = V(this).constructor;
              e = Reflect.construct(t, arguments, o);
            } else e = t.apply(this, arguments);

            return z(this, e);
          });

          function s(e) {
            var t;
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, s);
            var o = (t = c.call(this, e)).props,
                n = o.preferencesDefaultChecked,
                r = void 0 !== n && n,
                i = o.statisticsDefaultChecked,
                a = void 0 !== i && i,
                l = o.marketingDefaultChecked,
                u = void 0 !== l && l,
                f = o.wholeDomain,
                p = void 0 !== f && f;
            return t.state = {
              preferencesCookies: r,
              statisticsCookies: a,
              marketingCookies: u
            }, t.onScroll = t.onScroll.bind(K(t)), t.onTogglePreferencesCookies = t.onTogglePreferencesCookies.bind(K(t)), t.onToggleStatisticsCookies = t.onToggleStatisticsCookies.bind(K(t)), t.onToggleMarketingCookies = t.onToggleMarketingCookies.bind(K(t)), t.onAcceptAll = t.onAcceptAll.bind(K(t)), t.confirm = t.confirm.bind(K(t)), t.decline = t.decline.bind(K(t)), t.consetsCallback = t.consetsCallback.bind(K(t)), t.cookies = new v(p), t;
          }

          return t = s, (o = [{
            key: "componentDidMount",
            value: function value() {
              var e = this.props.dismissOnScroll;
              p() || !0 !== e || (window.addEventListener ? window.addEventListener("scroll", this.onScroll) : window.attachEvent && window.attachEvent("onscroll", this.onScroll));
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              p() || (window.removeEventListener ? window.removeEventListener("scroll", this.onScroll) : window.detachEvent && window.detachEvent("onscroll", this.onScroll));
            }
          }, {
            key: "onScroll",
            value: function value() {
              this.confirm();
            }
          }, {
            key: "onTogglePreferencesCookies",
            value: function value(e) {
              this.setState({
                preferencesCookies: e
              });
            }
          }, {
            key: "onToggleStatisticsCookies",
            value: function value(e) {
              this.setState({
                statisticsCookies: e
              });
            }
          }, {
            key: "onToggleMarketingCookies",
            value: function value(e) {
              this.setState({
                marketingCookies: e
              });
            }
          }, {
            key: "onAcceptAll",
            value: function value() {
              var e = this.props,
                  t = e.onAcceptPreferences,
                  o = void 0 === t ? function () {} : t,
                  n = e.onAcceptStatistics,
                  r = void 0 === n ? function () {} : n,
                  i = e.onAcceptMarketing,
                  c = void 0 === i ? function () {} : i;
              this.cookies.set(F), this.cookies.set(Q), this.cookies.set(J), this.cookies.set(Y), o(), r(), c(), this.forceUpdate();
            }
          }, {
            key: "confirm",
            value: function value() {
              var e = this.state,
                  t = e.preferencesCookies,
                  o = e.statisticsCookies,
                  n = e.marketingCookies;
              this.cookies.set(F), t ? this.cookies.set(Q) : this.cookies.remove(Q), o ? this.cookies.set(J) : this.cookies.remove(J), n ? this.cookies.set(Y) : this.cookies.remove(Y), this.forceUpdate();
            }
          }, {
            key: "decline",
            value: function value() {
              var e = this.props,
                  t = e.onDeclinePreferences,
                  o = void 0 === t ? function () {} : t,
                  n = e.onDeclineStatistics,
                  r = void 0 === n ? function () {} : n,
                  i = e.onDeclineMarketing,
                  c = void 0 === i ? function () {} : i;
              this.cookies.set(F), this.cookies.remove(Q), this.cookies.remove(J), this.cookies.remove(Y), o(), r(), c(), this.forceUpdate();
            }
          }, {
            key: "consetsCallback",
            value: function value() {
              var e = this.props,
                  t = e.onAccept,
                  o = void 0 === t ? function () {} : t,
                  n = e.onAcceptPreferences,
                  r = void 0 === n ? function () {} : n,
                  i = e.onAcceptStatistics,
                  c = void 0 === i ? function () {} : i,
                  s = e.onAcceptMarketing,
                  a = void 0 === s ? function () {} : s,
                  l = e.onDeclinePreferences,
                  u = void 0 === l ? function () {} : l,
                  f = e.onDeclineStatistics,
                  p = void 0 === f ? function () {} : f,
                  h = e.onDeclineMarketing,
                  y = void 0 === h ? function () {} : h,
                  d = this.cookies.get(Q),
                  g = this.cookies.get(J),
                  v = this.cookies.get(Y);
              o(), d ? r() : u(), g ? c() : p(), v ? a() : y();
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                  t = e.styles,
                  o = e.className,
                  n = e.message,
                  i = e.policyLink,
                  c = e.privacyPolicyLinkText,
                  s = e.necessaryOptionText,
                  a = e.preferencesOptionText,
                  l = e.statisticsOptionText,
                  u = e.marketingOptionText,
                  f = e.showDeclineButton,
                  p = e.acceptButtonText,
                  h = e.declineButtonText,
                  y = e.managePreferencesButtonText,
                  d = e.savePreferencesButtonText,
                  g = e.showPreferencesOption,
                  v = e.showStatisticsOption,
                  b = e.showMarketingOption,
                  m = e.preferencesDefaultChecked,
                  k = e.statisticsDefaultChecked,
                  O = e.marketingDefaultChecked;
              if (this.cookies.get(F)) return this.consetsCallback(), null;
              var w = {
                styles: t,
                className: o,
                message: n,
                policyLink: i,
                privacyPolicyLinkText: c,
                necessaryOptionText: s,
                preferencesOptionText: a,
                statisticsOptionText: l,
                marketingOptionText: u,
                showDeclineButton: f,
                acceptButtonText: p,
                declineButtonText: h,
                managePreferencesButtonText: y,
                savePreferencesButtonText: d,
                showPreferencesOption: g,
                showStatisticsOption: v,
                showMarketingOption: b,
                preferencesDefaultChecked: m,
                statisticsDefaultChecked: k,
                marketingDefaultChecked: O,
                onTogglePreferencesCookies: this.onTogglePreferencesCookies,
                onToggleStatisticsCookies: this.onToggleStatisticsCookies,
                onToggleMarketingCookies: this.onToggleMarketingCookies,
                onDecline: this.decline,
                onConfirm: this.confirm,
                onAcceptAll: this.onAcceptAll
              };
              return r().createElement(I, w);
            }
          }]) && H(t.prototype, o), s;
        }(r().Component);

        $.protoTypes = {
          className: c().string,
          styles: c().object,
          message: c().string.isRequired,
          wholeDomain: c().bool,
          policyLink: c().string,
          privacyPolicyLinkText: c().string,
          necessaryOptionText: c().string,
          preferencesOptionText: c().string,
          statisticsOptionText: c().string,
          marketingOptionText: c().string,
          acceptButtonText: c().string,
          declineButtonText: c().string,
          managePreferencesButtonText: c().string,
          savePreferencesButtonText: c().string,
          showDeclineButton: c().bool,
          dismissOnScroll: c().bool,
          showPreferencesOption: c().bool,
          showStatisticsOption: c().bool,
          showMarketingOption: c().bool,
          preferencesDefaultChecked: c().bool,
          statisticsDefaultChecked: c().bool,
          marketingDefaultChecked: c().bool,
          onAccept: c().func,
          onAcceptPreferences: c().func,
          onAcceptStatistics: c().func,
          onAcceptMarketing: c().func,
          onDeclinePreferences: c().func,
          onDeclineStatistics: c().func,
          onDeclineMarketing: c().func
        };
        var G = $;

        var X = function X(e) {
          return p() ? null : r().createElement(G, e);
        };
      },
      489: function _(e, t) {
        "use strict";

        t.Q = function (e, t) {
          if ("string" != typeof e) throw new TypeError("argument str must be a string");

          for (var n = {}, i = t || {}, s = e.split(r), a = i.decode || o, l = 0; l < s.length; l++) {
            var u = s[l],
                f = u.indexOf("=");

            if (!(f < 0)) {
              var p = u.substr(0, f).trim(),
                  h = u.substr(++f, u.length).trim();
              '"' == h[0] && (h = h.slice(1, -1)), null == n[p] && (n[p] = c(h, a));
            }
          }

          return n;
        }, t.q = function (e, t, o) {
          var r = o || {},
              c = r.encode || n;
          if ("function" != typeof c) throw new TypeError("option encode is invalid");
          if (!i.test(e)) throw new TypeError("argument name is invalid");
          var s = c(t);
          if (s && !i.test(s)) throw new TypeError("argument val is invalid");
          var a = e + "=" + s;

          if (null != r.maxAge) {
            var l = r.maxAge - 0;
            if (isNaN(l) || !isFinite(l)) throw new TypeError("option maxAge is invalid");
            a += "; Max-Age=" + Math.floor(l);
          }

          if (r.domain) {
            if (!i.test(r.domain)) throw new TypeError("option domain is invalid");
            a += "; Domain=" + r.domain;
          }

          if (r.path) {
            if (!i.test(r.path)) throw new TypeError("option path is invalid");
            a += "; Path=" + r.path;
          }

          if (r.expires) {
            if ("function" != typeof r.expires.toUTCString) throw new TypeError("option expires is invalid");
            a += "; Expires=" + r.expires.toUTCString();
          }

          if (r.httpOnly && (a += "; HttpOnly"), r.secure && (a += "; Secure"), r.sameSite) switch ("string" == typeof r.sameSite ? r.sameSite.toLowerCase() : r.sameSite) {
            case !0:
              a += "; SameSite=Strict";
              break;

            case "lax":
              a += "; SameSite=Lax";
              break;

            case "strict":
              a += "; SameSite=Strict";
              break;

            case "none":
              a += "; SameSite=None";
              break;

            default:
              throw new TypeError("option sameSite is invalid");
          }
          return a;
        };
        var o = decodeURIComponent,
            n = encodeURIComponent,
            r = /; */,
            i = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

        function c(e, t) {
          try {
            return t(e);
          } catch (t) {
            return e;
          }
        }
      },
      703: function _(e, t, o) {
        "use strict";

        var n = o(414);

        function r() {}

        function i() {}

        i.resetWarningCache = r, e.exports = function () {
          function e(e, t, o, r, i, c) {
            if (c !== n) {
              var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw s.name = "Invariant Violation", s;
            }
          }

          function t() {
            return e;
          }

          e.isRequired = e;
          var o = {
            array: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: i,
            resetWarningCache: r
          };
          return o.PropTypes = o, o;
        };
      },
      697: function _(e, t, o) {
        e.exports = o(703)();
      },
      414: function _(e) {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      297: function _(t) {
        "use strict";

        t.exports = e;
      }
    },
        o = {};

    function n(e) {
      if (o[e]) return o[e].exports;
      var r = o[e] = {
        exports: {}
      };
      return t[e](r, r.exports, n), r.exports;
    }

    return n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, {
        a: t
      }), t;
    }, n.d = function (e, t) {
      for (var o in t) {
        n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, {
          enumerable: !0,
          get: t[o]
        });
      }
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n(805);
  }();
});